// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"771":"8856bd31","4147":"8856bd31","6299":"8dbd19ee","9114":"8856bd31","9969":"8856bd31"}[chunkId] + ".chunk.css";
};